<template>
  <main id="selecionar-empresa" class="ohx login-modal">
    <v-content class="ohx">
      <v-container fluid grid-list-xs class="white-background ohx pb-4">
        <v-layout row wrap>
          <v-flex xs12 v-if="!showConfirmText">
            <h2 class="title">Bloquear Usuários</h2>
            <span class="close-button" @click.prevent="close()"
              ><v-icon>close</v-icon></span
            >

            <p class="description">
              Selecione os contatos que deseja bloquear.
            </p>
            <v-layout row wrap>
              <v-data-table
                v-if="users.contacts"
                :headers="headers"
                :items="users.contacts"
                :pagination.sync="pagination"
                :rows-per-page-items="[10, 20]"
                :loading="loading"
                :rows-per-page-text="'Linhas por página'"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">{{ props.item.email }}</td>
                  <td class="text-xs-left">{{ props.item.nome }}</td>
                  <td class="text-xs-right" width="8%">
                    <v-switch
                      :disabled="props.item.email == username"
                      v-model="props.item.blocked"
                      @click="toggleBlocked(props.item)"
                    ></v-switch>
                  </td>
                </template>

                <v-alert
                  slot="no-results"
                  :value="true"
                  color="error"
                  icon="warning"
                >
                  Sua pesquisa por "{{ search }}" não encontrou resultados.
                </v-alert>
              </v-data-table>
              <v-flex xs4 offset-xs8>
                <button
                  class="button jns-button yellow-button"
                  @click="close()"
                >
                  Fechar
                </button>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<style lang='scss' scoped>
#jns {
  .description {
    color: #888;
    font-size: 16px;
  }
  .title {
    font-weight: bold;
    margin-bottom: 10px;
    color: #4e4e4e;
  }
  .white-background {
  }
  .text--success {
    color: #4caf50;
  }
  .text--warning {
    color: #ffc107;
  }
  .text--error {
    color: #ff5252;
  }

  .text--primary {
    color: #c2c2c2;
  }
  .close-button {
    float: right;
    margin-top: -5px;
    cursor: pointer;
  }
}
</style>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";
export default {
  name: "BloquearUsuarioModal",
  mixins: [ViewMixin],
  data: () => ({
    alertText: false,
    showConfirmText: false,
    model: {},
    rules: {},
    loading: false,
    search: "",
    pagination: {},
    headers: [
      {
        text: "Email",
        align: "left",
        sortable: false,
      },
      {
        text: "Telefone",
        align: "left",
        sortable: false,
      },
      {
        text: "Bloquear",
        align: "right",
        sortable: false,
      },
    ],
  }),

  computed: {
    filteredItems() {},
  },
  methods: {
    close() {
      let t = this;
      t.$emit("close");
      setTimeout(() => {
        t.showConfirmText = false;
      }, 1000);
    },
    async toggleBlocked(user, $event) {
      let t = this;
      if (user.email == t.username) return;
      let response;
      let userId = user.id;
      let companyId = t.users.id;
      t.showLoadingIndicator();
      try {
        response = await t.$store.dispatch("TOGGLE_BLOCKED_USER", {
          userId,
          companyId,
        });
      } catch (e) {
        t.hideLoadingIndicator();
        return;
      }
      t.hideLoadingIndicator();
      user.blocked = !user.blocked;
      t.$forceUpdate();
    },
  },

  
  props: ["hash", "users", "companyId", "username"],
};
</script>





// WEBPACK FOOTER //
// ./src/components/BloquearUsuarioModal.vue